"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var Showroom = function Showroom(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 43 42"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M2.143 11.583V1.902h38.718v9.681zM41.553.52H1.451a.691.691 0 0 0-.691.691v11.063c0 .382.31.691.691.691h40.102c.382 0 .691-.31.691-.69V1.21a.691.691 0 0 0-.69-.691z"
  })), _path2 || (_path2 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M2.143 40.614v-15.21h38.718v15.21zm39.41-16.594H1.451a.691.691 0 0 0-.691.691v16.594c0 .382.31.691.691.691h40.102c.382 0 .691-.31.691-.691V24.71a.691.691 0 0 0-.69-.691z"
  })), _path3 || (_path3 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M13.198 8.811H4.904V4.663h8.294zm.693-5.531h-9.68a.691.691 0 0 0-.691.691v5.532c0 .381.31.69.691.69h9.68c.382 0 .691-.309.691-.69V3.97a.691.691 0 0 0-.69-.691z"
  })), _path4 || (_path4 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M11.13 5.36H6.982a.692.692 0 0 0 0 1.383h4.148a.692.692 0 0 0 0-1.383z"
  })), _path5 || (_path5 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M9.051 5.36a.691.691 0 0 0-.691.691v1.383a.691.691 0 1 0 1.383 0V6.051a.691.691 0 0 0-.692-.691z"
  })), _path6 || (_path6 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M38.088 8.811h-8.294V4.663h8.294zM29.1 3.28a.691.691 0 0 0-.691.691v5.532c0 .381.31.69.691.69h9.68c.382 0 .691-.309.691-.69V3.97a.691.691 0 0 0-.69-.691z"
  })), _path7 || (_path7 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M36.02 5.36h-4.148a.692.692 0 0 0 0 1.383h4.148a.692.692 0 0 0 0-1.383z"
  })), _path8 || (_path8 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M33.941 5.36a.691.691 0 0 0-.691.691v1.383a.691.691 0 1 0 1.383 0V6.051a.691.691 0 0 0-.692-.691z"
  })), _path9 || (_path9 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M25.65 8.811h-8.298V4.663h8.297zM16.66 3.28a.691.691 0 0 0-.691.691v5.532c0 .381.31.69.691.69h9.68c.382 0 .691-.309.691-.69V3.97a.691.691 0 0 0-.69-.691z"
  })), _path10 || (_path10 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M23.57 5.36h-4.148a.692.692 0 0 0 0 1.383h4.148a.692.692 0 0 0 0-1.383z"
  })), _path11 || (_path11 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M21.501 5.36a.691.691 0 0 0-.691.691v1.383a.692.692 0 0 0 1.383 0V6.051a.691.691 0 0 0-.692-.691z"
  })), _path12 || (_path12 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M38.106 32.321H22.193v-4.148h15.912zm.68-5.531H21.502a.691.691 0 0 0-.691.691v5.532c0 .381.31.69.691.69h17.285c.382 0 .691-.309.691-.69V27.48a.691.691 0 0 0-.69-.691z"
  })), _path13 || (_path13 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M32.56 28.86h-4.148a.692.692 0 1 0 0 1.383h4.148a.692.692 0 1 0 0-1.383z"
  })), _path14 || (_path14 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M30.491 28.86a.691.691 0 0 0-.691.691v1.383a.692.692 0 0 0 1.383 0v-1.383a.691.691 0 0 0-.692-.691z"
  })), _path15 || (_path15 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M38.106 37.851H22.193v-4.148h15.912zM21.5 32.32a.691.691 0 0 0-.691.691v5.532c0 .381.31.69.691.69h17.285c.382 0 .691-.309.691-.69V33.01a.691.691 0 0 0-.69-.691z"
  })), _path16 || (_path16 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M32.56 34.39h-4.148a.692.692 0 1 0 0 1.383h4.148a.692.692 0 1 0 0-1.383z"
  })), _path17 || (_path17 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M30.491 34.39a.691.691 0 0 0-.691.691v1.383a.692.692 0 0 0 1.383 0v-1.383a.691.691 0 0 0-.692-.691z"
  })), _path18 || (_path18 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M20.805 37.852H4.902v-9.679h15.903zM4.21 26.79a.691.691 0 0 0-.691.691v11.062c0 .382.31.692.691.692h17.285c.382 0 .691-.31.691-.692V27.481a.691.691 0 0 0-.69-.691z"
  })), _path19 || (_path19 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M15.28 30.25h-4.839a.691.691 0 0 0-.691.691v1.383a.692.692 0 0 0 1.383 0v-.691h3.457v.691a.692.692 0 0 0 1.383 0v-1.383a.691.691 0 0 0-.692-.691z"
  })), _path20 || (_path20 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M28.413 20.6h-5.531a.692.692 0 0 0 0 1.383h5.531a.692.692 0 0 0 0-1.383z"
  })), _path21 || (_path21 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M19.423 20.6h-5.531a.692.692 0 0 0 0 1.383h5.531a.692.692 0 0 0 0-1.383z"
  })), _path22 || (_path22 = /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M29.105 24.035H13.202v-1.393h15.903zm.691-2.775H12.511a.691.691 0 0 0-.691.691v2.766c0 .381.31.69.691.69h17.285c.382 0 .691-.309.691-.69V21.95a.691.691 0 0 0-.69-.691z"
  })));
};
var _default = exports.default = Showroom;